module.exports = __webpack_public_path__ + "svg/photo-delete.svg?2813e552d61ead6f45d29fd43f87c321";